import { STR_ERRORS } from "../../../common";
export function RESTResponseFormatter(response) {
    return new Promise((resolve, reject) => {
        if (!response.ok) {
            if (response.status === 502) {
                return reject(STR_ERRORS.BadGateway);
            }
            else {
                return typeof response.json === "function" ?
                    response.json().then(data => reject(data)) :
                    reject(STR_ERRORS.EmptyResponse);
            }
        }
        return resolve(response.json());
    });
}
//# sourceMappingURL=RESTResponseFormatter.js.map